import { useState } from "react";
import { apiFetch } from "api/Api";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "assets/theme/admin_form.css";

const AddDepartment = () => {
  const navigate = useNavigate();
  const [departmentName, setDepartmentName] = useState("");
  const [departmentEmail, setDepartmentEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const newErrors = {};
    if (!departmentName.trim()) {
      newErrors.departmentName = "Department name is required";
    }
    if (!departmentEmail.trim()) {
      newErrors.departmentEmail = "Department email is required";
    } else if (!/\S+@\S+\.\S+/.test(departmentEmail)) {
      newErrors.departmentEmail = "Please enter a valid email address";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);

    try {
      await apiFetch("super_admin/add_department", {
        method: "POST",
        body: JSON.stringify({ department_name: departmentName, email: departmentEmail }),
      });

      alert("Department added successfully");
      navigate("/department_list");
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid mt-4" style={{ fontSize: "0.9rem" }}>
        {/* Header Card */}
        <div className="admin-form-header-card">
          <div className="d-flex align-items-center gap-3">
            <button type="button" onClick={() => navigate(-1)} className="btn-admin-back">
              <FaArrowLeft />
              <span>मागे जा (Back)</span>
            </button>
            <div>
              <h4 className="fw-bold mb-1 text-white">
                🏛 नवीन विभाग जोडा (Add New Department)
              </h4>
              <small className="text-white-50">Create a department for complaint assignment</small>
            </div>
          </div>

          <Link to="/department_list" className="btn btn-light btn-sm fw-semibold rounded-pill px-3">
            Department List
          </Link>
        </div>

        <div className="card shadow-lg rounded-4 border-0">
          <div className="card-body p-4">
            <form onSubmit={handleSubmit} noValidate>
              <div className="row g-4">
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    Department Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.departmentName ? "is-invalid" : ""}`}
                    placeholder="e.g. Sanitation Department"
                    value={departmentName}
                    onChange={(e) => {
                      setDepartmentName(e.target.value);
                      if (errors.departmentName) setErrors((prev) => ({ ...prev, departmentName: "" }));
                    }}
                  />
                  {errors.departmentName ? (
                    <small className="text-danger d-block mt-1">{errors.departmentName}</small>
                  ) : (
                    <small className="text-muted d-block mt-1">
                      This department will be used for complaint routing.
                    </small>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    Department Email <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    className={`form-control ${errors.departmentEmail ? "is-invalid" : ""}`}
                    placeholder="e.g. sanitation@department.com"
                    value={departmentEmail}
                    onChange={(e) => {
                      setDepartmentEmail(e.target.value);
                      if (errors.departmentEmail) setErrors((prev) => ({ ...prev, departmentEmail: "" }));
                    }}
                  />
                  {errors.departmentEmail ? (
                    <small className="text-danger d-block mt-1">{errors.departmentEmail}</small>
                  ) : (
                    <small className="text-muted d-block mt-1">
                      This department email will be used for complaint routing.
                    </small>
                  )}
                </div>
              </div>

              <div className="mt-4 text-end">
                <button type="submit" className="btn btn-primary px-5" disabled={loading} style={{ fontSize: "0.85rem" }}>
                  {loading ? "Saving..." : "Save Department"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AddDepartment;
